<mat-chip-set>
    @for (filterChip of filterChips$ | async; track filterChip; let index = $index) {
        <mat-chip
            (removed)="removeFilterChip(filterChip)">
            <strong class="mat-body-2">{{ filterChip.text }}</strong>
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>
    }
</mat-chip-set>
